import { useState, useEffect } from "react";
import {
  buildStyles,
  CircularProgressbarWithChildren,
} from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { PROFILE_PECENTAGE, profileStatusColor } from "../constant";


export const ProfileStatus = ({ isProgressBarRequired = true, ...props}) => {
  const { statusValue, statusImage } = props;

  const [profileColor, setProfileColor] = useState('');
  useEffect(() => {
  if (statusValue >= PROFILE_PECENTAGE[0] && statusValue < PROFILE_PECENTAGE[64]) {
      setProfileColor(profileStatusColor.yellow);
    } else if (statusValue >= PROFILE_PECENTAGE[64] && statusValue < PROFILE_PECENTAGE[85]) {
      setProfileColor(profileStatusColor.orange);
    } else if (statusValue >= PROFILE_PECENTAGE[85] && statusValue <= PROFILE_PECENTAGE[100]) {
      setProfileColor(profileStatusColor.green);
    } else {
      setProfileColor(profileStatusColor.yellow);
    }
  }, [statusValue]);

  return (
    <div style={{ width: 50, height: 50 }}>
      <CircularProgressbarWithChildren
        value={statusValue}
        circleRatio={0.75}
        styles={buildStyles({
          rotation: 1 / 2 + 1 / 8,
          strokeLinecap: "butt",
          trailColor: profileColor.trailColor,
          pathColor: profileColor.pathColor, 
        })}
      >
        <img
          style={{ width: 24, height: 24, marginTop: -5 }}
          src={statusImage}
          alt="DoctorImage"
        />

      </CircularProgressbarWithChildren>

      <div className={`flex justify-center bg-[${profileColor.textColor}] rounded relative text-xs font-semibold -mt-2 ml-2 w-8`} style={{ backgroundColor: profileColor.textColor }}>{statusValue}%</div>
    </div>
  );
}

